import React, {Component} from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { onUnsubClick } from '../../utils/unsubHelper'
import { getText } from '../../constants/multiDomains';

class Footer extends Component {
    render() {
        return (
					(config.domain == 'pt')
					?<div className='pt-footer'>
						<div >
						<a className='pt-list-item' href="http://n.mobi360vr.com/pt/tnc-mobio360?device=pc&offer=1" target="_blank">
							<FormattedHTMLMessage id="tnc"
								defaultMessage="Terms &amp; Conditions"
							/></a> |
							<a className='pt-list-item' href={`/#/account?uid=${this.props.access.uid}`} target="_blank">
							<FormattedHTMLMessage id="myAcc"
								defaultMessage="My Account"
							/></a> |
							 <a className='pt-list-item' href='' target="_blank" onClick={onUnsubClick}>
								<FormattedHTMLMessage id="unsub"
									defaultMessage="Unsubscribe"
								/></a>
						</div>
					</div>
                    :(config.domain=='ee')?
                    <footer className="app-footer">
                        <ul className="list-unstyled footer-list">
                            <li className="footer-list__item"><a className="footer-list__link" href="http://n.mobi360vr.com/ee/tnc-mobio360?offer=1">
										<FormattedHTMLMessage id="tnc"
											defaultMessage="Terms &amp; Conditions"
										/>
								</a>
                            </li>
                        </ul>
                    </footer>
					:(config.domain==='eg')?
                    <footer className="app-footer">
                        <ul className="list-unstyled footer-list">
                            <li className="footer-list__item"><a className="footer-list__link" href={`http://n.mobi360vr.com/eg/eg-mm-mobio360?offer=1&msisdn=${this.props.access.subscriptionInfo ? this.props.access.subscriptionInfo.msisdn_full : ""}`}>
										<FormattedHTMLMessage id="tnc"
											defaultMessage="Terms &amp; Conditions"
										/>
								</a>
                            </li>
                        </ul>
                    </footer>
					:(config.domain=='za')?
                    <footer className="app-footer">
                        <ul className="list-unstyled footer-list">
                            <li className="footer-list__item"><a className="footer-list__link" href="http://n.mobi360vr.com/za/tnc-mobio360?device=pc&offer=1">
										<FormattedHTMLMessage id="tnc"
											defaultMessage="Terms &amp; Conditions"
										/>
								</a>
                            </li>
                        </ul>
                    </footer>
					:
						<footer className="app-footer">
							<div>
								<h4 className="h4">
									<FormattedMessage id="mobiletainment"
										defaultMessage="Mobiletainment With No Limits"
									/>
								</h4>
								<ul className="list-unstyled footer-list">
									<li className="footer-list__item"><a className="footer-list__link" href="/#/about">
										<FormattedMessage id="about"
											defaultMessage="About"
										/>
									</a></li>
									<li className="footer-list__item"><a className="footer-list__link" href="/#/privacy-policy">
										<FormattedMessage id="privacyPolicy"
											defaultMessage="Privacy Policy"
										/>
									</a></li>
									<li className="footer-list__item"><a className="footer-list__link" href="/#/terms-conditions">
										<FormattedHTMLMessage id="tnc"
											defaultMessage="Terms &amp; Conditions"
										/>
									</a></li>
								</ul>
								<div className="copyright">
									<p className="copyright__text">
										{getText() === "Mobio360" ? 
										<FormattedHTMLMessage id="copyright"
											defaultMessage="2019 &copy; Mobio360. All Rights Reserved."
										/> 
										:
										<FormattedHTMLMessage id="copyright"
											defaultMessage="2019 &copy; Mobio360+. All Rights Reserved."
										/>} 
									</p>
								</div>
							</div>
						</footer>
			
        )
    }
}
const mapStateToProps = (state) => {
	return {
		access: state.WelcomeReducer
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js